import { lazy } from 'react'

export const DeactivateInstanceModalAsync = lazy(() => import('./DeactivateInstanceModal')
    .then((module) => ({ default: module.DeactivateInstanceModal }))
)
